import { useCallback } from 'react';

import ErrorReporter from '@lyearn/core/utils/ErrorReporter';
import { useTranslation } from '@lyearn/i18n';
import { Trans } from '@lyearn/i18n';
import { useSnackbar } from '@lyearn/ui';
import useNavigation from '@/hooks/useNavigation';

export const useContentPublishCallback = () => {
  const { t } = useTranslation();
  const { showSnackbar, showErrorSnackbar } = useSnackbar();
  const navigation = useNavigation();

  const onSuccess = useCallback(
    (redirectURL: string, contentStringKey: string, note?: string | null) => {
      showSnackbar({
        message: (
          <Trans
            i18nKey={'Admin:Publish.SuccessMessage'}
            values={{
              contentType: note ? t('Admin:Publish.Changes') : t(contentStringKey),
            }}
          />
        ),
      });
      navigation.push(redirectURL);
    },
    [navigation, showSnackbar, t],
  );

  const onError = useCallback(
    (e: any) => {
      showErrorSnackbar({ message: t('Common:Error.SomethingWentWrong') });
      ErrorReporter.error(e);
    },
    [showErrorSnackbar, t],
  );

  return { onSuccess, onError };
};
